// 부트스트랩 설정.
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
window._ = require('lodash');
window.feather = require("feather-icons");
window.axios = require('axios');
window.Vue = require('vue').default;
window.ToastUiEditor = require('@toast-ui/editor');
window.Chart = require('chart.js/auto');
window.tinyMCE = require('tinymce');

import "jquery-mask-plugin/dist/jquery.mask.min";
import "jquery-ui/ui/widgets/sortable";
import 'select2';

import '@simonwep/pickr/dist/themes/classic.min.css';
import Pickr from '@simonwep/pickr';

window.Pickr = Pickr;

import Swiper from 'swiper/bundle';
import moment, {fn} from "moment"

window.Swiper = Swiper;
window.moment = moment;

require('bootstrap');

window.mwHelper = require("./helper").default;


window.initTinyMCE = function(extraOptions = {}){
    $('.-js-tinymce').each(function () {
        const me = $(this);
        const key = me.data('key');

        window.loadScript('https://cdn.tiny.cloud/1/' + key + '/tinymce/7/tinymce.min.js')
            .then(data => {
                tinymce.init({
                    selector: '.-js-tinymce',
                    language: 'ko_KR',
                    plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount code',
                    toolbar: 'code image link table align | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | media | lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                    file_picker_types: 'image',
                    images_reuse_filename: true,
                    images_upload_handler: (blobInfo, progress) => {
                        return new Promise((resolve, reject) => {
                            const xhr = new XMLHttpRequest();
                            xhr.withCredentials = false;
                            xhr.open('POST', me.data('uploaded-url'));
                            xhr.setRequestHeader('Accept', 'application/json');

                            xhr.upload.onprogress = (e) => {
                                progress(e.loaded / e.total * 100);
                            };

                            xhr.onload = () => {
                                if (xhr.status === 403) {
                                    reject({message: 'HTTP Error: ' + xhr.status, remove: true});
                                    return;
                                }

                                if (xhr.status < 200 || xhr.status >= 300) {
                                    reject('HTTP Error: ' + xhr.status);
                                    return;
                                }

                                const json = JSON.parse(xhr.responseText);

                                if (!json || typeof json.location != 'string') {
                                    reject('Invalid JSON: ' + xhr.responseText);
                                    return;
                                }

                                resolve(json.location);
                            };

                            xhr.onerror = () => {
                                reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
                            };

                            const formData = new FormData();
                            formData.append('file', blobInfo.blob(), blobInfo.filename());

                            xhr.send(formData);
                        });
                    },
                    ...extraOptions
                });
            })
            .catch(err => {
                console.error(err);
            });
    });
}

// 아이콘 설정.
document.addEventListener("DOMContentLoaded", () => {
    feather.replace();
    $('[data-toggle="tooltip"]').tooltip();

    $("body").on("click", ".popup-open", function (e) {
        e.preventDefault();

        const me = $(this);
        let url = me.data("url");
        let name = me.data("name");
        let width = parseInt(me.data("width"));
        let height = parseInt(me.data("height"));
        let top = parseInt(me.data("top"));
        let left = parseInt(me.data("left"));

        let screenWidth = screen.availWidth;

        if (!name) name = "popup-" + Math.floor(Math.random() * 1000000);
        if (!width) width = 800;
        if (!height) height = 600;
        if (!top) top = 100;
        if (!left) left = (screenWidth - width) / 2;

        window.open(url, name, "scrollbars=1,resizable=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left)
    }).on("mouseenter", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").addClass("td-mouseover-bg");
    }).on("mouseleave", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").removeClass("td-mouseover-bg");
    });

    // 휴대전화번호 형식 처리.
    const mask_hp = function (val) {
        const masks = ['000-0000-0000', '000-000-00009'];
        return (val.replace(/[^0-9]/g, "").length === 10) ? masks[1] : masks[0];
    };

    $('.mask-hp').each(function () {
        const me = $(this);

        me.mask(mask_hp(me.val()), {
            onKeyPress: function (cep, e, field, options) {
                field.mask(mask_hp(cep), options);
            }
        })
    });

    // 전화번호 형식 처리.
    const mask_tel = function (val) {
        const masks = [
            '00-000-0000999',
            '000-000-000099',
            '000-0000-00009',
            '0000-0000-0000',
        ];

        let mask = masks[0];

        switch (val.replace(/[^0-9]/g, "").length) {
            case 10 :
                mask = masks[1];
                break
            case 11 :
                mask = masks[2];
                break
            case 12 :
                mask = masks[3];
                break
        }

        return mask;
    };

    $('.mask-tel').each(function () {
        const me = $(this);

        me.mask(mask_tel(me.val()), {
            onKeyPress: function (cep, e, field, options) {
                field.mask(mask_tel(cep), options);
            }
        });
    });

    initTinyMCE();
});

// 크로스 사이트 처리를 위한 코드.
// 다른 도메인의 사이트에서 데이터를 전달 받음.
window.addEventListener('message', function (e) {
    if (e.data.callback) {
        // ...처리 로직 (부모창 함수 호출)
        const fn = window[e.data.callback];
        if (typeof fn === 'function') {
            const args = Array.isArray(e.data.arguments)
                ? e.data.arguments
                : [e.data.arguments];

            fn(...args);
        }
    }
});


/**
 * 지도 검색.
 * @param callback
 */
window.search_address = function (callback) {
    const callbackName = "cb" + Math.round((Math.random() * 1000000000));
    const url = "http://order.maruw.co.kr/popup/address?callback=" + callbackName + "&delivery_charge=on";
    const width = 550;
    const left = (screen.availWidth - width) / 2;

    window[callbackName] = function (data) {
        let deliveryCharge = data.deliveryCharge;

        if (typeof deliveryCharge == "string") {
            deliveryCharge = parseInt(deliveryCharge);
        }

        callback({
            address: data.address,
            address_detail: data.detail,
            zipcode: data.zipcode || '00000',
            deliveryCharge: deliveryCharge,
        });
    };

    window.open(url, callbackName, "scrollbars=1,resizable=1,width=" + width + ",height=550,top=100,left=" + left);
};


/**
 * 지도 검색.
 * @param url
 * @param width
 * @param height
 * @param top
 * @param left
 * @param name
 * @param blockChecked
 */
window.popup_open = function (url, width, height, top, left, name) {
    if (!name) name = "popup-" + Math.floor(Math.random() * 1000000);
    if (!width) width = 800;
    if (!height) height = 600;
    if (!top) top = 100;
    if (!left) left = (screenWidth - width) / 2;

    let popup = window.open(url, name, "scrollbars=1,resizable=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);

    if (!popup) {
        setTimeout(() => {
            alert("브라우저의 팝업이 차단되어 있습니다.\n항상 허용으로 설정한 후 다시 시도해 주세요.");
        }, 1000);
    }
};

window.loadScript = function (FILE_URL, async = true, type = "text/javascript") {
    return new Promise((resolve, reject) => {
        try {
            const scriptEle = document.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;

            scriptEle.addEventListener("load", (ev) => {
                resolve({status: true});
            });

            scriptEle.addEventListener("error", (ev) => {
                reject({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                });
            });

            document.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};
